import { Box, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { FC } from 'react';
import { CompanyVerificationStatus } from '../gql-types.generated';

// Single source of truth for verification status label + colour, shared by the all-tenants
// table and the tenant settings panel so the two can't drift.
export const verificationStatusConfig: Record<CompanyVerificationStatus, { label: string; color: string }> = {
  [CompanyVerificationStatus.Unspecified]: { label: 'Not onboarded', color: '#9E9E9E' },
  [CompanyVerificationStatus.Pending]: { label: 'Pending', color: '#FF9800' },
  [CompanyVerificationStatus.Unverified]: { label: 'Unverified', color: '#F44336' },
  [CompanyVerificationStatus.Verified]: { label: 'Verified', color: '#4CAF50' },
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cell: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    dot: {
      width: 10,
      height: 10,
      borderRadius: '50%',
      flexShrink: 0,
    },
  }),
);

interface VerificationStatusIndicatorProps {
  status?: CompanyVerificationStatus | null;
  className?: string;
}

const VerificationStatusIndicator: FC<VerificationStatusIndicatorProps> = ({ status, className }) => {
  const classes = useStyles();
  const config = verificationStatusConfig[status ?? CompanyVerificationStatus.Unspecified];
  return (
    <Box className={className ? `${classes.cell} ${className}` : classes.cell}>
      <Box className={classes.dot} style={{ backgroundColor: config.color }} />
      <Typography variant="body1">{config.label}</Typography>
    </Box>
  );
};

export default VerificationStatusIndicator;
